import React, { Component } from 'react';
import "./toolbar.css";
import Search from "./search"
import Select, { Creatable, Async } from 'react-select';
import classNames from 'classnames';

import { SingleDatePicker } from 'react-dates'
import 'react-dates/initialize';
import moment from 'moment';
import es from 'moment/locale/es';
import 'react-dates/lib/css/_datepicker.css';
import { Link, Redirect } from 'react-router-dom';
import { api } from 'api';

let movimientos = [
    {id: true, value: true, label:"Ingreso"},
    {id: false, value: false, label:"Egreso"},
]
let ESTADOS_PAGO = [
    {value: 0, label: "TODOS"},
    {value: 1, label: "CERRADO"},
    {value: 2, label: "PENDIENTE DE PAGO"},
]
let ESTADOS = [
    { value: 3, label: "TODOS"},
    { value: 1, label: "ACTIVOS"},
    { value: 2, label: "ANULADOS"},
]

const getVendedores = (search, props) => {
    let params = {search}
    params.is_active = true

    return api.get("liquidaciones/get_usuarios_vendedores_liquidaciones", params).
        then((data) => {
            if (data) return data.results;
            return [];
        }).catch(() => {
            return [];
        });
};

export default class ToolbarValesGasolina extends Component {
    state = {
        dateStart: moment.now(),
        focusedStart: false,

        dateEnd: moment.now(),
        focusedEnd: false,

        vendedoresOptions: null,
    }

    componentWillMount() {
        const resul = getVendedores('', this.props)
        resul.then((valor) => {
            this.setState({ vendedoresOptions: valor })
        });
    }

    render() {
        const { valorEstado, setEstado, valorEstadoPago, setEstadoPago } = this.props;

        return (
            <div className="row col-12 p-0">
                <div className="row col-12 m-0 justify-content-end align-items-end">
                    <div className={"col-lg-2 col-md-3 col-12"}>
                        <span className="t-azul-claro font-weight-bold">Fecha Inicial</span>
                        <SingleDatePicker
                        className="form-control"
                        placeholder={"Fecha Inicio"}
                        date={this.props.dateStart ? moment(this.props.dateStart ) : null}
                        focused={this.state.focusedStart}
                        isOutsideRange={() => false}
                        onDateChange={(value) => {
                        this.setState({dateStart:value})
                        this.props.setDateStart(value)
                        }}
                        onFocusChange={({ focused }) => this.setState({ focusedStart: focused })}
                        numberOfMonths={1}
                        id={"dateStart"}
			            readOnly = { true }
                    />
                    </div>
                    <div className={"col-lg-2 col-md-3 col-12"}>
                        <span className="t-azul-claro font-weight-bold">Fecha Final</span>
                        <SingleDatePicker
                        className="form-control"
                        placeholder={"Fecha Final"}
                        date={this.props.dateEnd ? moment(this.props.dateEnd ) : null}
                        focused={this.state.focusedEnd}
                        isOutsideRange={() => false}
                        onDateChange={(value) => {
                           this.setState({dateEnd:value})
                           this.props.setDateEnd(value);
                        }}
                        onFocusChange={({ focused }) => this.setState({ focusedEnd: focused })}
                        numberOfMonths={1}
                        id={"dateStart"}
			            readOnly = { true }
                    />
                    </div>

                    <div className={"col-lg-4 col-md-3 col-12"}>
                        <span className="t-azul-claro font-weight-bold">Vendedor</span>
                        <Async
                            isClearable={true}
                            backspaceRemovesValue={false}
                            isSearchable={true}
                            loadOptions={(search) => getVendedores(search, this.props)}
                            getOptionValue={(option) => (option["id"])}
                            getOptionLabel={(option) => (`${option["first_name"]} ${option["last_name"]}`)}
                            type="text"
                            onChange={(e) => {
                                e ? this.props.changeVendedor(e.id) : this.props.changeVendedor(null)
                            }}
                            // cacheOptions
                            multi={true}
                            autoload={false}
                            cache={false}
                            className={classNames('react-select-container ')}
                            defaultOptions={this.state.vendedoresOptions}
                            placeholder="Seleccionar.."
                        />
                    </div>

                    <div className={"col-lg-2 col-md-3 col-12"}>
                        <span className="t-azul-claro font-weight-bold">Estado Pago</span>
                        <Select
                            isClearable={false}
                            className={classNames('react-select-container')}
                            backspaceRemovesValue={false}
                            isSearchable={true}
                            options={ESTADOS_PAGO}
                            placeholder={"Estado Pago"}
                            defaultValue={valorEstadoPago}
                            onChange={(e) => {
                                setEstadoPago(e.value)
                            }}
                        />
                    </div>
                    <div className={"col-lg-2 col-md-3 col-12"}>
                        <span className="t-azul-claro font-weight-bold">Estado</span>
                        <Select
                            isClearable={false}
                            className={classNames('react-select-container')}
                            backspaceRemovesValue={false}
                            isSearchable={true}
                            options={ESTADOS}
                            placeholder={"Movimiento"}
                            defaultValue={valorEstado}
                            onChange={(e) => {
                                setEstado(e.value)
                            }}
                        />
                    </div>
                </div>

                <div className="row col-12 m-0 justify-content-end align-items-end">
                    {(this.props.buscar !== undefined) && (
                        <div className="col-lg-4 col-md-3 col-12">
                            <span>&nbsp;</span>
                            <Search buscar={this.props.buscar} buscador={this.props.buscador} placeholder={this.props.placeholder} />
                        </div>
                    )}
                    {
                        (this.props.downloadButton && this.props.downloadButton.handleDownload) && (
                            <div className="col-auto pr-md-0 pt-3 pt-md-0">
                            <button type="button" className="btn btn-primary" onClick={() => {this.props.downloadButton.handleDownload()}}>
                                {this.props.downloadButton.label}
                            </button>
                            </div>
                        )
                    }
                    {
                        (this.props.textBoton) && this.props.permisos && (
                        <div className="col-auto pr-md-0 pt-3 pt-md-0">
                            <Link className={`btn btn-${this.props.textBoton2 ? 'secondary' : 'primary'} text-uppercase`} to={this.props.ruta}>{this.props.textBoton}</Link>
                        </div>
                        )
                    }
                </div>
            </div>
        )
    }
}
